// 管理用户数据相关

import { defineStore } from 'pinia'
import { ref } from 'vue'
import { loginAPI,loginGoogleAPI,loginTelegramAPI,userAPI,getExchangeRateAPI } from '@/apis/user'
import { useCartStore } from './cartStore'
import { mergeCartAPI } from '@/apis/cart'
import { ElMessage } from 'element-plus'

export const useUserStore = defineStore('user', () => {
    const CurrencyAll=ref([]);
    const Currency=ref([])
    const exchangeRate=ref({})
    const userIp=ref();
    const ipTime=ref()
    const serviceStatus=ref(false)
    const cartStore = useCartStore()
    // 1. 定义管理用户数据的state
    const userInfo = ref({})
    // 2. 定义获取接口数据的action函数
    const getUserInfo = async (data) => {
        //登录
        const res = await loginAPI(data)
        if(res.code==0){
            userInfo.value ={...res.data}
            //获取用户数据
            getUser()
        }else{
            ElMessage({ type: 'error', message: res.message })
        }
        
        // userInfo.value = res.result
        // 合并购物车的操作
        // await mergeCartAPI(cartStore.cartList.map(item => {
        //     return {
        //         skuId: item.skuId,
        //         selected: item.selected,
        //         count: item.count
        //     }
        // }))
        // cartStore.updateNewList()
    }
    
    const getTelegramUserInfo = async (data) => {
        //登录
        const res = await loginTelegramAPI(data)
        if(res.code==0){
            if(res.data.new_user){
                ElMessage({ type: 'success', message: 'Please provide complete personal information' })
            }
            
            userInfo.value ={...res.data}
            //获取用户数据
            getUser()
        }else{
            ElMessage({ type: 'error', message: res.message })
        }
        
        // userInfo.value = res.result
        // 合并购物车的操作
        // await mergeCartAPI(cartStore.cartList.map(item => {
        //     return {
        //         skuId: item.skuId,
        //         selected: item.selected,
        //         count: item.count
        //     }
        // }))
        // cartStore.updateNewList()
    }
    const getGoogleUserInfo = async (data) => {
        //登录
        const res = await loginGoogleAPI(data)
        if(res.code==0){
            if(res.data.new_user){
                ElMessage({ type: 'success', message: 'The initial password has been sent to the email' })
            }
            
            userInfo.value ={...res.data}
            //获取用户数据
            getUser()
        }else{
            ElMessage({ type: 'error', message: res.message })
        }
        
        // userInfo.value = res.result
        // 合并购物车的操作
        // await mergeCartAPI(cartStore.cartList.map(item => {
        //     return {
        //         skuId: item.skuId,
        //         selected: item.selected,
        //         count: item.count
        //     }
        // }))
        // cartStore.updateNewList()
    }
    const getUser=async ()=>{
        //获取用户数据
        const res = await userAPI()
        if(res.code==0){
            userInfo.value ={...userInfo.value,...res.data.userInfo}
        }else{
          ElMessage({ type: 'error', message: res.message })
            
        }
    }
    const getRate=async ()=>{
        console.log('获取汇率');
        const res = await getExchangeRateAPI()
        if (res.code == 0) {
           CurrencyAll.value=res.data.data;
           localStorage.setItem('CurrencyAll',JSON.stringify(CurrencyAll.value))
           Currency.value=res.data.data.filter(rate => rate.symbol !== "￥");
           const Currencycheck=localStorage.getItem('CurrencyLANGUAGE')
           exchangeRate.value=CurrencyAll.value.find(rate => rate.currency === Currencycheck);
           console.log()
           
        } else {
            ElMessage({ type: 'error', message: res.message })
        }
    }

    // 退出时清除用户信息
    const clearUserInfo = () => {
        userInfo.value = {}
        // 执行清除购物车的action
        cartStore.clearCart()
    }

    // 3. 以对象的格式把state和action return
    return {
        serviceStatus,
        userInfo,
        exchangeRate,
        CurrencyAll,
        Currency,
        getUserInfo,
        getGoogleUserInfo,
        getTelegramUserInfo,
        clearUserInfo,
        getUser,
        userIp,
        ipTime,
        getRate
    }
}, {
    persist: true,
})